var config = {
  dev: {
    env: 'dev',
    pxAppId: 'PX7sZ6Hw9L',
    pxCheggClientOrigin: 'https://trunk.live.test.cheggnet.com',
    pxAuthGateClientOrigin: 'https://gateway.test.cheggnet.com',
    baseUrl: 'https://trunk.live.auth.test.cheggnet.com',
    authClusterUrl: 'https://trunk.live.auth.test.cheggnet.com/auth/_ajax/auth/v1',
    termsOfUseLink: 'https://www.chegg.com/termsofuse',
    forgotPasswordCustomerService: 'https://www.chegg.com/contactus/46870233/',
    reCaptchaSiteKey: '6LdOKyUUAAAAAGQA6eSitOi0_MrbwGfuop0Lbxsx',
    privacyPolicyLink: 'https://www.chegg.com/privacypolicy',
    cookieNoticeLink: 'https://www.chegg.com/cookienotice',
    oneAuthSocial: 'https://gateway.test.cheggnet.com/one-auth-social',
    newRelicAccountNumber: '501278',
    newRelicUrl: 'https://insights-collector.newrelic.com/v1/accounts/',
    newRelicKey: 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg',
    redirectUri: 'https://trunk.live.test.cheggnet.com/',
    customerServiceUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forcePasswordResetFAQUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forterSiteId: '60e8740d4be6',
    forterEuToken: '22g4zl{5jf5fjtlv1forxgiurqw1qhw2vwdwxv',
    contentful: {
      host: 'cdn.contentful.com',
      space: 'r3serv063pl2',
      environment: 'test',
      accessToken: 'ORMeZCR0iNrZC24J47_VkM0Cp_pXGl6hwveq5mCZzMU'
    },
    contentfulPreview: {
      host: 'preview.contentful.com',
      environment: 'test',
      space: 'r3serv063pl2',
      accessToken: 'z1UVCfP2woHbA6uElRFCQjGrJysSlq6kEifvVJoGEvk'
    },
    optimizelyConfig: {
      cookieDomain: '.cheggnet.com',
      project_id: '16624190478',
      sdkKey: 'Wrm1ShQjJHp7FYJNHrqL2e',
      dataFileScript: 'https://cdn.optimizely.com/datafiles/Wrm1ShQjJHp7FYJNHrqL2e.json/tag.js'
    },
    gcid: '896229455474-1b4fb9g3e44754o6ooncr5opnkhten9d.apps.googleusercontent.com'
  },
  test: {
    env: 'test',
    pxAppId: 'PX7sZ6Hw9L',
    pxCheggClientOrigin: 'https://trunk.live.test.cheggnet.com',
    pxAuthGateClientOrigin: 'https://gateway.test.cheggnet.com',
    baseUrl: 'https://trunk.live.auth.test.cheggnet.com',
    authClusterUrl: 'https://trunk.live.auth.test.cheggnet.com/auth/_ajax/auth/v1',
    oneAuthSocial: 'https://gateway.test.cheggnet.com/one-auth-social',
    termsOfUseLink: 'https://www.chegg.com/termsofuse',
    forgotPasswordCustomerService: 'https://www.chegg.com/contactus/46870233/',
    reCaptchaSiteKey: '6LdOKyUUAAAAAGQA6eSitOi0_MrbwGfuop0Lbxsx',
    privacyPolicyLink: 'https://www.chegg.com/privacypolicy',
    cookieNoticeLink: 'https://www.chegg.com/cookienotice',
    newRelicAccountNumber: '501278',
    newRelicUrl: 'https://insights-collector.newrelic.com/v1/accounts/',
    newRelicKey: 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg',
    redirectUri: 'https://trunk.live.test.cheggnet.com/',
    customerServiceUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forcePasswordResetFAQUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forterSiteId: '60e8740d4be6',
    forterEuToken: '22g4zl{5jf5fjtlv1forxgiurqw1qhw2vwdwxv',
    contentful: {
      host: 'cdn.contentful.com',
      space: 'r3serv063pl2',
      environment: 'test',
      accessToken: 'ORMeZCR0iNrZC24J47_VkM0Cp_pXGl6hwveq5mCZzMU'
    },
    contentfulPreview: {
      host: 'preview.contentful.com',
      environment: 'test',
      space: 'r3serv063pl2',
      accessToken: 'z1UVCfP2woHbA6uElRFCQjGrJysSlq6kEifvVJoGEvk'
    },
    optimizelyConfig: {
      cookieDomain: '.cheggnet.com',
      project_id: '16624190478',
      sdkKey: 'Wrm1ShQjJHp7FYJNHrqL2e',
      dataFileScript: 'https://cdn.optimizely.com/datafiles/Wrm1ShQjJHp7FYJNHrqL2e.json/tag.js'
    },
    gcid: '896229455474-1b4fb9g3e44754o6ooncr5opnkhten9d.apps.googleusercontent.com'
  },
  prod: {
    env: 'prod',
    pxAppId: 'PXzYvFOXaC',
    pxCheggClientOrigin: 'https://www.chegg.com',
    pxAuthGateClientOrigin: 'https://gateway.chegg.com',
    baseUrl: 'https://auth.chegg.com/',
    authClusterUrl: 'https://auth.chegg.com/auth/_ajax/auth/v1',
    oneAuthSocial: 'https://gateway.chegg.com/one-auth-social',
    termsOfUseLink: 'https://www.chegg.com/termsofuse',
    forgotPasswordCustomerService: 'https://www.chegg.com/contactus/46870233/',
    reCaptchaSiteKey: '6LdOKyUUAAAAAGQA6eSitOi0_MrbwGfuop0Lbxsx',
    privacyPolicyLink: 'https://www.chegg.com/privacypolicy',
    cookieNoticeLink: 'https://www.chegg.com/cookienotice',
    newRelicAccountNumber: '501356',
    newRelicUrl: 'https://insights-collector.newrelic.com/v1/accounts/',
    newRelicKey: 'NRII-Mi0ZOVEe_ofN3PNkKFbYnXl2rhtskKKD',
    redirectUri: 'https://www.chegg.com/',
    customerServiceUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forcePasswordResetFAQUrl: 'https://www.chegg.com/contactus?a=How-do-I-manage-my-password---id--Awsl2NTvTdyqWBiu1nIVBg',
    forterSiteId: '4d504a8c7797',
    forterEuToken: '22g4zl{5jf5fjtlv1forxgiurqw1qhw2vwdwxv',
    contentful: {
      host: 'cdn.contentful.com',
      space: 'r3serv063pl2',
      environment: 'master',
      accessToken: 'ORMeZCR0iNrZC24J47_VkM0Cp_pXGl6hwveq5mCZzMU'
    },
    contentfulPreview: {
      host: 'preview.contentful.com',
      environment: 'test',
      space: 'r3serv063pl2',
      accessToken: 'z1UVCfP2woHbA6uElRFCQjGrJysSlq6kEifvVJoGEvk'
    },
    optimizelyConfig: {
      cookieDomain: '.chegg.com',
      project_id: '16624190478',
      sdkKey: '293KxffvUkJMLzB21vpMzE',
      dataFileScript: 'https://cdn.optimizely.com/datafiles/293KxffvUkJMLzB21vpMzE.json/tag.js'
    },
    gcid: '791213825812-pae51bjtt5gbiib9qg5fen7tabfose83.apps.googleusercontent.com'
  }
};
export default config;